import { render, staticRenderFns } from "./itemFormExperiment.vue?vue&type=template&id=bd8cf148&"
import script from "./itemFormExperiment.vue?vue&type=script&lang=js&"
export * from "./itemFormExperiment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports